import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { DateSelectService } from './date-select.service';


@Injectable({
  providedIn: 'root'
})
export class FlowDataService {

  // Set up flow BehaviorSubject
  private flowSource = new BehaviorSubject<FlowData[]>([]);
  currentFlow = this.flowSource.asObservable();

  constructor(private http: HttpClient, private dateSelectObject: DateSelectService, @Inject('BASE_URL') private baseUrl: string) {

    // Whenever you get a date, grab the excess flow data without geo
    this.dateSelectObject.currentDate.subscribe((result) => {
      this.getFlow(result);
    });

  }

  // Call API to get new Flow data
  getFlow(date) {
    this.http.get<FlowDataResponse>(`${this.baseUrl}api/ExcessFlowByDate/${date}/`).subscribe(
      result => {
        if (Array.isArray(result) && result) {
          /*  Remove null items */
          result.forEach(x => Object.keys(x).forEach(y => x[y] == null ? delete x[y] : y));
          let reachdata = [];
          for (let i = 0; i < result.length; i++) {            
            reachdata[i] = result[i];
            reachdata[i]['inView'] = true;
            reachdata[i]['selected'] = false;

            // Temporary fix while data model is enforced on the back end
            reachdata[i]['Demand'] = parseInt(reachdata[i]['Demand']);
            reachdata[i]['PotentialDemand'] = parseInt(reachdata[i]['PotentialDemand']);
            reachdata[i]['ExcessFlowFromMaxDemand'] = parseInt(reachdata[i]['ExcessFlowFromMaxDemand']);
            reachdata[i]['Gain'] = parseInt(reachdata[i]['Gain']);
            reachdata[i]['NaturalFlow'] = parseInt(reachdata[i]['NaturalFlow']);
            reachdata[i]['TotalNaturalFlow'] = parseInt(reachdata[i]['TotalNaturalFlow']);
            reachdata[i]['TotalUpstreamOutFlow'] = parseInt(reachdata[i]['TotalUpstreamOutFlow']);
            reachdata[i]['StorageOutFlow'] = parseInt(reachdata[i]['StorageOutFlow']);
            reachdata[i]['EAOutFlow'] = parseInt(reachdata[i]['EAOutFlow']);
            reachdata[i]['ActualCanalDiversion'] = parseInt(reachdata[i]['ActualCanalDiversion']);
            reachdata[i]['CanalCapacity'] = parseInt(reachdata[i]['CanalCapacity']);
            reachdata[i]['TargetFlowGrandIsland'] = parseInt(reachdata[i]['TargetFlowGrandIsland']);
            reachdata[i]['ReachNumber'] = parseInt(reachdata[i]['ReachNumber']);
            reachdata[i]['NonConsumptiveDemand'] = parseInt(reachdata[i]['NonConsumptiveDemand']);
          }
          this.changeFlow(reachdata);  
        } else {
          this.changeFlow([]);
        }
      },
      error => console.error(error)
    );
  }

  // Update Flow BehaviorSubject
  changeFlow(flow) {
    this.flowSource.next(flow);
  }

}

export interface FlowDataResponse {
  FlowData: FlowData[];
}

export interface FlowData {
  PwapReportId: number;
  ReachNumber: number;
  ReachName: string;
  ReachStartName: string;
  ReachEndName: string;
  ExcessFlowDate: Date;
  NaturalFlow: number;
  TotalNaturalFlow: number;
  Gain: number;
  Demand: number;
  NonConsumptiveDemand: number;
  ExcessFlowFromMaxDemand: number;
  TotalUpstreamOutFlow: number;
  StorageOutFlow: number;
  EAOutFlow: number;
  ActualCanalDiversion: number;
  CanalCapacity: number;
  TargetFlowGrandIsland: number;
  inView: boolean;
  selected: boolean;
}
